<script>
  import WideButton from "../WideButton.svelte";
  import BackToTopButton from "../Navigation/BackToTopButton.svelte";
  import { getDateString, getTimeString } from "../../services/timeStrings";
  import moment from "moment";
  import {
    addChatMessage,
    onChatMessageRecieved,
    unsubscribeToChat
  } from "../../services/flamelink";
  import { afterUpdate } from "svelte";

  export let user;

  const onChangeChatText = (event) => {
    let text = event.target.value;
    inputText = text;
    // TODO: HOOK INTO VALUE VAR FOR INPUT
  };

  $: chat = [];
  $: chatRaw = []; // TODO: This is bad, but im on a time limit.. I couldnt get the subscription to switch from one filter to another.. so im subscribing to everything and filtering it here. Forgive me mom.
  $: inputText = "";

  function submitChatMessage() {
    if(inputText.trim() == "") {
      inputText = ""
      return;
    }

    let message = inputText;
    let challengeId = 'NO_ID';
    let username = user.username;

    inputText=""
    addChatMessage(message, challengeId, username);
  }

  function compare( a, b ) {
  if ( a.unixTime < b.unixTime ){
    return -1;
  }
  if ( a.unixTime > b.unixTime ){
    return 1;
  }
  return 0;
}

    function onTextAdded(message) {
      chatRaw = [...chatRaw, ...message];
      chat = chatRaw.sort(compare).reverse();
    }

    onChatMessageRecieved(onTextAdded, 'NO_ID');

  afterUpdate(() => {
    chat = chatRaw.sort(compare).reverse();
  });

  function handleKeyup(event) {
    console.log(event.keyCode)
    if(event.keyCode == 13) {
      // submitChatMessage()
    }
  } 

</script>

<h1 class="header_text">MESSAGE BOARD</h1>
<div style="position: relative">
  <textarea
  value={inputText}
    class="chat_box"
    placeholder="Type something..."
    on:input={onChangeChatText}
    on:keyup|preventDefault={handleKeyup}
  />
  <p class="input_header">{user.username} • {getDateString(moment().unix())}</p>
</div>

<WideButton onClick={submitChatMessage} text={`SEND MESSAGE`} />

<div style="height: 25px" />

{#each chat as chatMessage, i}
  <div
    style="width: 100%;"
    class="chat_message {i == chat.length - 1 ? 'no_border' : ''}"
  >
    <div style="display: flex; justify-content: space-between; height: 25px">
      <p class="chat_message_text sm">
        {chatMessage.username + " "}•{" " + getDateString(chatMessage.unixTime)}
      </p>
      <p class="chat_message_text sm">{getTimeString(chatMessage.unixTime)}</p>
    </div>
    <p class="chat_message_text">{chatMessage.message}</p>
  </div>
{/each}

{#if chat.length > 10}
  <BackToTopButton />
{/if}

<style>
  .no_border {
    border: none !important;
  }

  .chat_message {
    padding-bottom: 10px;
    margin-bottom: 20px;
    border-bottom: 2px solid #ffffff88;
  }
  .chat_message_text {
    color: white;
    font-family: "Courier New", Courier, monospace;
    font-size: 13px;
    line-height: 18px;
    word-break: break-word;
  }

  .sm {
    font-size: 11px;
  }

  .input_header {
    position: absolute;
    top: 15px;
    left: 15px;
    font-size: 11px;
  }

  .chat_box {
    width: 100%;
    height: 200px;
    border: 1px solid white;
    background-color: black;
    color: white;
    position: relative;
    padding-top: 35px;
    padding-left: 15px;
    font-family: "Courier New", Courier, monospace;
    font-size: 13px;
  }
</style>
